import { FormEvent, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useResetPasswordMutation } from '../features/auth/api/authApiSlice';
import { useBrandTheme } from '../components/providers/brand-theme-provider.utils';

export const ResetPasswordPage = () => {
  const { brandName } = useBrandTheme();
  const [params] = useSearchParams();
  const token = useMemo(() => (params.get('token') || '').slice(0, 256), [params]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setMessage(null);
    if (!token) {
      setMessage('El enlace no contiene un token válido.');
      return;
    }
    if (password.length < 8 || password.length > 128) {
      setMessage('La contraseña debe tener entre 8 y 128 caracteres.');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('Las contraseñas no coinciden.');
      return;
    }

    try {
      const result = await resetPassword({ token, newPassword: password }).unwrap();
      setMessage(result.message);
      setDone(true);
      setPassword('');
      setConfirmPassword('');
    } catch {
      setMessage('El enlace es inválido, venció o ya fue utilizado.');
    }
  };

  return (
    <div className='flex min-h-screen flex-col justify-center bg-background px-6 py-12'>
      <div className='mx-auto w-full max-w-sm rounded-lg border bg-card px-6 py-8 text-card-foreground shadow-sm'>
        <h1 className='text-2xl font-bold'>Nueva contraseña de {brandName}</h1>
        {message && <p className='mt-4 text-sm'>{message}</p>}
        {done ? (
          <Link className='mt-6 block underline' to='/login'>Iniciar sesión</Link>
        ) : (
          <form className='mt-6 space-y-4' onSubmit={submit}>
            <div>
              <label className='block text-sm font-medium' htmlFor='new-password'>Nueva contraseña</label>
              <input
                id='new-password'
                type='password'
                autoComplete='new-password'
                required
                minLength={8}
                maxLength={128}
                value={password}
                onChange={event => setPassword(event.target.value)}
                className='mt-1 w-full rounded-md border bg-background px-3 py-2'
              />
            </div>
            <div>
              <label className='block text-sm font-medium' htmlFor='confirm-password'>Repetir contraseña</label>
              <input
                id='confirm-password'
                type='password'
                autoComplete='new-password'
                required
                minLength={8}
                maxLength={128}
                value={confirmPassword}
                onChange={event => setConfirmPassword(event.target.value)}
                className='mt-1 w-full rounded-md border bg-background px-3 py-2'
              />
            </div>
            <button
              type='submit'
              disabled={isLoading || !token}
              className='w-full rounded-md bg-primary px-4 py-2 font-medium text-primary-foreground disabled:opacity-50'
            >
              {isLoading ? 'Guardando…' : 'Cambiar contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
